
export default function UnitWarningContainer({ colorStyles = 'text-grey-100 border-grey-100', children }) {
  return(
    <div className={`${colorStyles} flex flex-col items-center my-2 mx-2 w-full border rounded`}>
      {children}
    </div>
  )
}